import apiClient from '../apiClient';

const notificacionesServices = {

  actualizarNotificacion: async (resource, id, formData) => {
    try {
      
      const response = await apiClient.put(`/${resource}/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  crearNotificacion: async (resource, formData) => {
    try {
      const response = await apiClient.post(`/${resource}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarAdjuntoNotificacion: async (resource, id, id_adjunto) => {
    try {
      const response = await apiClient.delete(`/${resource}/${id}/eliminarAdjunto/${id_adjunto}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default notificacionesServices;
